import { createContext, useContext } from 'react';

/**
 * Maps toolName → toolResult.content (JSON string) for the current message.
 *
 * Chat cards are rendered from fenced markdown blocks that the LLM writes.
 * The LLM sometimes omits fields (resourceTags, asset, etc.) that exist in the
 * real toolResult JSON. This context lets the markdown renderers access the
 * actual toolResult data so they can merge any missing fields back in.
 */
type ToolResultDataMap = Record<string, string>;

export const ToolResultDataContext = createContext<ToolResultDataMap>({});

/**
 * Returns the raw toolResult JSON string for the given tool name, or undefined
 * if no toolResult exists for that tool in the current message.
 */
export function useToolResultContent(toolName: string): string | undefined {
  const map = useContext(ToolResultDataContext);
  return map[toolName];
}
